import { StyledButton } from '@/lib/theme/components/Button';
import { Flex, Input, Tag, Typography } from 'antd';
import { useState } from 'react';
import themeToken from '@lib/theme/tokens/index';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';

const { Text } = Typography;

type MultipleTextInputsProps = {
  setTexts: (texts: string[]) => void;
  texts?: string[];
  subText?: string;
};

const MultipleTextInputs = ({ setTexts, texts, subText }: MultipleTextInputsProps) => {
  const [inputValue, setInputValue] = useState<string>('');

  const onAddClick = () => {
    if (inputValue.trim() === '') return;
    const newTexts = texts ? [...texts, inputValue.trim()] : [inputValue.trim()];
    setTexts(newTexts);
    setInputValue('');
  };

  return (
    <Flex style={{ width: '100%' }} vertical gap={8}>
      <Flex gap={8}>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          addonAfter={<StyledButton size="small" type="text" icon={<PlusOutlined />} onClick={onAddClick} />}
        />
      </Flex>
      <Flex gap={8} style={{ padding: '5px' }} wrap="wrap">
        {subText && (
          <Text
            style={{
              color: themeToken['branding-primary-6'],
              fontSize: themeToken.fontSize,
            }}
          >
            {subText}
          </Text>
        )}
        {texts &&
          texts.map((text, index) => (
            <Tag
              closeIcon={
                <CloseOutlined
                  style={{
                    color: themeToken['branding-primary-3'],
                  }}
                />
              }
              closable
              onClose={() => {
                const newTexts = texts.filter((_, i) => i !== index);
                setTexts(newTexts);
              }}
              color={themeToken['branding-primary-1']}
              style={{
                margin: 0,
                color: themeToken['branding-primary-6'],
                borderColor: themeToken['branding-primary-3'],
              }}
              key={index}
            >
              {text}
            </Tag>
          ))}
      </Flex>
    </Flex>
  );
};

export default MultipleTextInputs;
